<div
    class="anc-alert"
    [ngClass]="'anc-alert--' + variant()"
    [attr.role]="variant() === 'error' ? 'alert' : 'status'"
    *ngIf="!closed()"
>
    <span class="anc-alert__icon icon" [ngClass]="iconClass()" aria-hidden="true"></span>
    <div class="anc-alert__body">
        <ng-content></ng-content>
    </div>
    <button
        type="button"
        class="anc-alert__close"
        *ngIf="dismissible()"
        (click)="dismiss()"
        [attr.aria-label]="'Dismiss' | translate"
    >
        &times;
    </button>
</div>
